export default {"src":"/_next/static/media/raydium-logo.9acbe7dd.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};